export const Warning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
    <rect width={39} height={39} x={0.5} y={0.5} fill="#1C1A24" rx={14.5} />
    <rect width={39} height={39} x={0.5} y={0.5} stroke="#1C1A24" rx={14.5} />
    <circle cx={20} cy={20} r={10.25} stroke="#fff" strokeWidth={1.5} />
    <path stroke="#fff" strokeLinecap="round" strokeWidth={1.5} d="M20 15.07v4.55" />
    <circle cx={20} cy={23.793} r={1.138} fill="#fff" />
  </svg>
)
